import React, { PropTypes } from 'react';
import ImageSequenceItem from './ImageSequenceItem.jsx';


class ImageSequence extends React.Component {

  // ==================================================================================
  // CONSTRUCTOR ----------------------------------------------------------------------

  constructor() {
    super();

    this.state = {
      timer: null,
      activeItem: 0,
      sequenceItems: 6
    }

    this.handleTimerInterval = this.handleTimerInterval.bind(this);
  }


  // ==================================================================================
  // EVENT INTERFACE ------------------------------------------------------------------

  handleTimerInterval() {
    let activeItem = this.state.activeItem+1;
    activeItem = activeItem === this.state.sequenceItems ? 0 : activeItem;

    this.setState({ activeItem: activeItem });
  }


  // ==================================================================================
  // INTERNAL INTERFACE ---------------------------------------------------------------

  componentDidMount() {
    this.state.timer = setInterval(this.handleTimerInterval, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.state.timer);
  }

	// TODO: Randomize ImageSequenceItem order
  render() {
    return (
      <div className="image-sequence">
        {[...Array(this.state.sequenceItems)].map((x, i) =>
          <ImageSequenceItem key={i}
                             src={"/static/images/home/bg-"+ (i+1) +".jpg"}
                             active={ this.state.activeItem == i } />
        )}
      </div>
    );
  }
}


export default ImageSequence;



/** WEBPACK FOOTER **
 ** ./src/app/components/ui/animation/ImageSequence.jsx
 **/